<template lang="pug">
.preview-page
  .summary-top
        .summary-top__info.info-summary
            .info-summary__ava К
            .info-summary__info
                .info-summary__title Меладзе в Рыбинске
                .info-summary__text Рыбинск, Дворец спорта "Полет", 16 октября, 19:00
  .preview-page__top
    h2.h2.activity-inner__h2 Интеграции
    a(href='#' @click.prevent="onSidebar" v-show="this.windowWidth < 1200").sidebar-gamb
      svgicon(name='gamb')
  .tabs.tabs--widget
    .tabs__title
      a(href='#' 
        v-for="tab in tabs" 
        :key="tab.name" 
        :class="[{active: currentTab === tab.name}]" 
        @click.prevent="currentTab = tab.name"
      ).tabs__link {{ tab.title }}
    .tabs__content
      component(:is="currentTab").tab

      

</template>

<script>
import YM from '@/components/tabs/YM.vue'

import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  name: 'IntegrationActivity',
  components: {
    YM,
  },
  data: function() {
    return {
      currentTab: 'YM',
      tabs: [
        {
          name: 'YM',
          title: 'Яндекс.Метрика'
        },
        {
          name: 'GA',
          title: 'Google Analytics'
        },
        {
          name: 'mail',
          title: 'Mail.ru'
        },
        {
          name: 'RT',
          title: 'Ретаргетинг (пиксель)'
        },
      ],
      windowWidth: null,
    }
  },
  mounted: function(){
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    ...mapMutations([
      'onSidebar',
    ]),
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
      const desktop = this.windowWidth  > 768;
      this.$set(this.tabs[0], 'title', desktop ? 'Яндекс.Метрика' : 'Я.Метрика');
      this.$set(this.tabs[1], 'title', desktop ? 'Google Analytics' : 'GA');
      this.$set(this.tabs[2], 'title', desktop ? 'Mail.ru' : 'Mail.ru');
      this.$set(this.tabs[3], 'title', desktop ? 'Ретаргетинг (пиксель)' : 'RT');
    },
  },
  computed:{
    ...mapGetters([
      'sidebar',
    ]),
  },
}
</script>

<style lang="scss">
.activity-inner{
  .h3{
    margin-top: 0;
  }
  &__h2{
    margin-top: 0;
    margin-bottom: 15px;
  }
  &__flex{
    display: flex;
  }
  &__col{
    width: 400px;
    max-width: 100%;
    &:first-child{
      margin-right: 100px;
    }
  }
}  
.form__group--hidden-date{
  margin-bottom: 30px;
  display: block;
  .form__group {
      margin-right: 10px;
      margin-left: 20px;
      &:first-child{
          margin-left: 0;
      }
  }
}
.preview-page__top{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  .h2{
    margin-bottom: 5px;
  }
  .sidebar-gamb{
    margin-left: auto;
  }
}
@media (max-width: 1339px) {
  .activity-inner__col:first-child{
    margin-right: 50px;
  } 
}
@media (max-width: 1200px) {
  .activity-inner__flex{
    flex-direction: column;
  }
}
@media (max-width: 767px) {
  .activity-inner__col:first-child {
    margin-right: 0;
  }
  .activity-inner__content{
    padding: 30px 20px;
  }
  .activity-inner__flex {
    .form__input{
      width: 350px;
    }
  }
}
@media (max-width: 479px) {
  .activity-inner__flex {
    .form__input{
      width: calc(100% - 30px);
      box-sizing: border-box;
    }
  }
}
</style>